import React, { useCallback, useState } from 'react';
import { Tooltip } from 'react-tooltip';

type ComponentProps = {
  term: string;
  useDisabledColor?: boolean;
  shouldDisable?: boolean;
  deleteTerm: (term: string) => void;
};

const TermPill: React.FC<ComponentProps> = (props) => {
  const { term, deleteTerm, useDisabledColor = false, shouldDisable = false } = props;
  const [ref, setRef] = useState<HTMLParagraphElement | null>(null);

  const onRefChange = useCallback((node) => {
    setRef(node); // e.g. change ref state to trigger re-render
  }, []);

  const getBgColor = (): string => {
    if (useDisabledColor) return 'bg-litlingo-alert-light';
    return 'bg-litlingo-success-light';
  };

  return (
    <div className="flex flex-row items-center">
      <div
        className={`px-1 py-0.5 flex flex-row items-center gap-1 text-small rounded ${getBgColor()}`}
      >
        {ref && ref.scrollWidth > ref.clientWidth && <Tooltip id={term} />}
        <p className="truncate" data-tip={term} data-for={term} ref={onRefChange}>
          {term}
        </p>
        <button
          className="self-center focus:outline-none"
          type="button"
          disabled={shouldDisable}
          onClick={(): void => {
            deleteTerm(term);
          }}
        >
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="5" cy="5" r="5" fill="#ADADAD" />
            <path
              d="M3.56055 3.56006L6.47255 6.47246"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.47255 3.56006L3.56055 6.47246"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default TermPill;
